var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "activity-page"
  }, [_c('div', {
    staticClass: "banner-container"
  }, [_c('img', {
    staticClass: "banner-img",
    attrs: {
      "src": "https://filedlabeljs.ctaiot.com/dlabel_vue/dlabel_pc_web/img/active-page/double-twelve-pc.jpg",
      "alt": "双12活动"
    }
  }), _c('div', {
    staticClass: "hotspot",
    staticStyle: {
      "top": "80.4%",
      "left": "23%",
      "width": "13%",
      "height": "7.2%"
    },
    on: {
      "click": function click($event) {
        return _vm.goDetail(384);
      }
    }
  }), _c('div', {
    staticClass: "hotspot",
    staticStyle: {
      "top": "80.4%",
      "left": "37%",
      "width": "13%",
      "height": "7.2%"
    },
    on: {
      "click": function click($event) {
        return _vm.goDetail(389);
      }
    }
  }), _c('div', {
    staticClass: "hotspot",
    staticStyle: {
      "top": "80.4%",
      "left": "50.2%",
      "width": "13%",
      "height": "7.2%"
    },
    on: {
      "click": function click($event) {
        return _vm.goDetail(390);
      }
    }
  }), _c('div', {
    staticClass: "hotspot",
    staticStyle: {
      "top": "80.4%",
      "right": "23%",
      "width": "13%",
      "height": "7.2%"
    },
    on: {
      "click": function click($event) {
        return _vm.goDetail(794);
      }
    }
  }), _c('div', {
    staticClass: "hotspot",
    staticStyle: {
      "top": "87.8%",
      "left": "23%",
      "width": "13%",
      "height": "7.2%"
    },
    on: {
      "click": function click($event) {
        return _vm.goDetail(449);
      }
    }
  }), _c('div', {
    staticClass: "hotspot",
    staticStyle: {
      "top": "87.8%",
      "left": "37%",
      "width": "13%",
      "height": "7.2%"
    },
    on: {
      "click": function click($event) {
        return _vm.goDetail(138);
      }
    }
  }), _c('div', {
    staticClass: "hotspot",
    staticStyle: {
      "top": "87.8%",
      "left": "50.2%",
      "width": "13%",
      "height": "7.2%"
    },
    on: {
      "click": function click($event) {
        return _vm.goDetail(741);
      }
    }
  }), _c('div', {
    staticClass: "hotspot",
    staticStyle: {
      "top": "87.8%",
      "right": "23%",
      "width": "13%",
      "height": "7.2%"
    },
    on: {
      "click": function click($event) {
        return _vm.goDetail(509);
      }
    }
  }), _c('div', {
    staticClass: "hotspot",
    staticStyle: {
      "bottom": "0%",
      "right": "0%",
      "width": "100%",
      "height": "4.6%"
    },
    on: {
      "click": function click($event) {
        return _vm.goHome();
      }
    }
  })])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };